export enum FileType {
  Image = 'image',

  LottieImage = 'lottie-image',

  Video = 'video',

  Other = 'other',
}
